import React from 'react';

function DashboardNews(props) {
  var t = props.t;
  var isRTL = props.isRTL;
  var lang = props.lang;
  var now = props.now;
  var newsItems = props.newsItems;
  var newsItemsLoading = props.newsItemsLoading;
  var newsFilter = props.newsFilter;
  var setNewsFilter = props.setNewsFilter;
  var filteredNews = props.filteredNews;
  var openNewsSummary = props.openNewsSummary;
  var newsPopup = props.newsPopup;
  var setNewsPopup = props.setNewsPopup;
  var newsSummary = props.newsSummary;
  var newsLoading = props.newsLoading;
  var exchangeRates = props.exchangeRates;
  var ratesLoading = props.ratesLoading;
  var ratesUpdatedAt = props.ratesUpdatedAt;
  var NEWS_FILTER_TABS = props.NEWS_FILTER_TABS;

  return (<>
    {/* ═══ 4행: 뉴스 위젯 + 환율 위젯 ═══ */}
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
      {/* 뉴스 위젯 */}
      <div className="card" style={{padding:20}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
          <h3 style={{margin:0,fontSize:15,fontWeight:700,color:'#0f172a'}}>{t.industryNews}</h3>
          <span style={{fontSize:10,color:'#94a3b8'}}>{t.newsSource} · {newsItems.length}{t.items}</span>
        </div>
        <div style={{display:'flex',gap:4,marginBottom:12,flexWrap:'wrap'}}>
          {NEWS_FILTER_TABS.map(function(tab){
            var isActive=newsFilter===tab.id;
            var cnt=tab.id==='all'?newsItems.length:newsItems.filter(function(n){return n.region===tab.id}).length;
            return(<button key={tab.id} style={{padding:'4px 10px',borderRadius:6,fontSize:10,fontWeight:isActive?700:500,border:'1px solid '+(isActive?'#3b82f6':'#e5e7eb'),background:isActive?'#eff6ff':'#fff',color:isActive?'#2563eb':'#64748b',cursor:'pointer',transition:'all .15s'}} onClick={function(){setNewsFilter(tab.id)}}>
              {tab.label}{cnt>0?' '+cnt:''}
            </button>);
          })}
        </div>
        <div style={{maxHeight:280,overflowY:'auto'}}>
          {newsItemsLoading&&<div style={{color:'#94a3b8',fontSize:12,padding:20,textAlign:'center'}}>{t.newsCollecting}</div>}
          {!newsItemsLoading&&filteredNews.length===0&&<div style={{color:'#94a3b8',fontSize:12,padding:20,textAlign:'center'}}>{t.noNews}</div>}
          {filteredNews.map(function(n,i){
            return(<div key={i} style={{display:'flex',gap:10,padding:'9px 4px',borderBottom:i<filteredNews.length-1?'1px solid #f1f5f9':'none',cursor:'pointer',transition:'background .15s',borderRadius:4}} onClick={function(){openNewsSummary(n)}}>
              <div style={{fontSize:14,flexShrink:0,paddingTop:1}}>{n.flag}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:500,color:'#334155',lineHeight:1.5,marginBottom:3,overflow:'hidden',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical'}}>{n.title}</div>
                <div style={{display:'flex',gap:6,alignItems:'center'}}>
                  <span style={{fontSize:9,fontWeight:700,color:n.tagColor,background:n.tagColor+'15',padding:'1px 7px',borderRadius:4}}>{n.regionLabel}</span>
                  <span style={{fontSize:9,color:'#b0b8c4'}}>{n.source}</span>
                  <span style={{fontSize:9,color:'#cbd5e1'}}>{n.time}</span>
                </div>
              </div>
              <div style={{fontSize:10,color:'#94a3b8',flexShrink:0,paddingTop:2,whiteSpace:'nowrap'}}>{t.newsSummary} →</div>
            </div>);
          })}
        </div>
      </div>

      {/* 환율 위젯 */}
      <div className="card" style={{padding:20}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <h3 style={{margin:0,fontSize:15,fontWeight:700,color:'#0f172a'}}>{t.exchangeRate}</h3>
          <span style={{fontSize:11,color:'#94a3b8'}}>open.er-api.com · {ratesUpdatedAt?ratesUpdatedAt.toLocaleTimeString(lang==='ar'?'ar-SA':'ko-KR',{hour:'2-digit',minute:'2-digit'}):now.toLocaleTimeString(lang==='ar'?'ar-SA':'ko-KR',{hour:'2-digit',minute:'2-digit'})} {t.basis}</span>
        </div>
        {ratesLoading&&<div style={{color:'#94a3b8',fontSize:13,padding:20,textAlign:'center'}}>{t.checking}</div>}
        {!ratesLoading&&exchangeRates.length===0&&<div style={{color:'#94a3b8',fontSize:13,padding:20,textAlign:'center'}}>{t.noNews}</div>}
        {exchangeRates.map(function(r,i){
          var isUp=r.change>0;
          var isDown=r.change<0;
          var changeColor=isUp?'#16a34a':isDown?'#dc2626':'#999';
          var arrow=isUp?'▲':isDown?'▼':'—';
          return(<div key={i} style={{display:'flex',alignItems:'center',padding:'12px 14px',borderRadius:10,marginBottom:6,background:'#f8fafc',border:'1px solid #e5e7eb',direction:'ltr'}}>
            <span style={{fontSize:22,marginRight:12}}>{r.flag}</span>
            <div style={{flex:1}}>
              <div style={{display:'flex',alignItems:'baseline',gap:6}}>
                <span style={{fontWeight:700,fontSize:14,color:'#1e293b'}}>{r.currency}</span>
                <span style={{fontSize:10,color:'#94a3b8'}}>{r.name}</span>
              </div>
              <div style={{fontSize:10,color:'#94a3b8',marginTop:2}}>1 {r.currency} = KRW</div>
            </div>
            <div style={{textAlign:'right'}}>
              <div style={{fontWeight:800,fontSize:17,color:'#1e293b',fontFamily:'Outfit,monospace'}}>{r.rate<10?r.rate.toFixed(3):r.rate.toLocaleString('ko-KR',{minimumFractionDigits:2,maximumFractionDigits:2})}</div>
              <div style={{fontSize:13,fontWeight:600,color:changeColor,marginTop:2}}>
                {arrow} {Math.abs(r.change).toFixed(2)} ({isUp?'+':''}{r.pct.toFixed(2)}%)
              </div>
            </div>
          </div>);
        })}
      </div>
    </div>

    {/* ═══ 뉴스 요약 팝업 ═══ */}
    {newsPopup&&<div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}} onClick={function(){setNewsPopup(null)}}>
      <div style={{background:'#fff',borderRadius:16,width:520,maxWidth:'90vw',maxHeight:'80vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,0.25)',direction:isRTL?'rtl':'ltr'}} onClick={function(e){e.stopPropagation()}}>
        <div style={{padding:'20px 24px 16px',borderBottom:'1px solid #e5e7eb'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:12}}>
            <div style={{flex:1}}>
              <h3 style={{margin:0,fontSize:16,fontWeight:700,color:'#0f172a',lineHeight:1.4}}>{newsPopup.title}</h3>
              <div style={{display:'flex',gap:8,alignItems:'center',marginTop:8}}>
                <span style={{fontSize:12,marginRight:2}}>{newsPopup.flag}</span>
                <span style={{fontSize:10,fontWeight:700,color:newsPopup.tagColor,background:newsPopup.tagColor+'15',padding:'2px 10px',borderRadius:4}}>{newsPopup.regionLabel||newsPopup.tag}</span>
                <span style={{fontSize:11,color:'#94a3b8'}}>{t.source}: {newsPopup.source} · {newsPopup.time}</span>
              </div>
            </div>
            <button onClick={function(){setNewsPopup(null)}} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#94a3b8',padding:4,lineHeight:1}}>✕</button>
          </div>
        </div>
        <div style={{padding:'20px 24px'}}>
          {newsLoading&&<div style={{textAlign:'center',padding:'30px 0'}}>
            <div style={{display:'inline-block',width:28,height:28,border:'3px solid #e5e7eb',borderTopColor:'#3b82f6',borderRadius:'50%',animation:'spin .7s linear infinite'}}></div>
            <div style={{marginTop:12,fontSize:13,color:'#64748b'}}>{t.analyzing}</div>
          </div>}
          {!newsLoading&&newsSummary&&newsSummary.error&&<div style={{background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,padding:14,fontSize:12,color:'#dc2626'}}>
            {newsSummary.error}
          </div>}
          {!newsLoading&&newsSummary&&!newsSummary.error&&<div>
            <div style={{marginBottom:20}}>
              <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:10}}>
                <span style={{fontSize:16}}>📝</span>
                <span style={{fontSize:13,fontWeight:700,color:'#0f172a'}}>{t.aiSummary}</span>
                {!newsSummary.hasDescription&&<span style={{fontSize:9,color:'#94a3b8',marginLeft:4}}>{t.rssNote}</span>}
              </div>
              {newsSummary.bullets.map(function(b,i){
                return(<div key={i} style={{display:'flex',gap:8,padding:'6px 0',fontSize:13,color:'#334155',lineHeight:1.6}}>
                  <span style={{color:'#3b82f6',fontWeight:700,flexShrink:0}}>•</span>
                  <span>{b}</span>
                </div>);
              })}
            </div>
            {newsSummary.impact&&<div style={{background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:10,padding:'12px 16px'}}>
              <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:6}}>
                <span style={{fontSize:14}}>💡</span>
                <span style={{fontSize:12,fontWeight:700,color:'#1e40af'}}>{t.impact}</span>
              </div>
              <div style={{fontSize:13,color:'#1e3a5f',lineHeight:1.6}}>{newsSummary.impact}</div>
            </div>}
          </div>}
        </div>
        <div style={{padding:'12px 24px 20px',display:'flex',justifyContent:'space-between',gap:12}}>
          {newsPopup.url&&<a href={newsPopup.url} target="_blank" rel="noopener noreferrer" style={{padding:'8px 20px',borderRadius:8,fontSize:12,fontWeight:600,border:'1px solid #d0d5dd',background:'#fff',color:'#334155',textDecoration:'none',cursor:'pointer',display:'inline-flex',alignItems:'center',gap:4}}>🔗 {t.viewOriginal}</a>}
          <button onClick={function(){setNewsPopup(null)}} style={{padding:'8px 24px',borderRadius:8,fontSize:12,fontWeight:700,border:'none',background:'linear-gradient(135deg,#1e40af,#3b82f6)',color:'#fff',cursor:'pointer',marginLeft:'auto'}}>{t.close}</button>
        </div>
      </div>
    </div>}
  </>);
}

export default DashboardNews;
